import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_list_table_viewer';
export const useUserListTableViewerTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });
export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    table: {
      status: 'Статус',
      full_name: 'Имя',
      email: 'Email',
      role: 'Роль',
      last_login_at: 'Последний вход',
      department: 'Подразделение',
    },
    status: {
      system: 'Системный',
      active: 'Активный',
      blocked: 'Заблокирован',
      pending: 'Ожидает установки пароля',
    },
    departments: {
      more: 'Еще {{count}}',
    },
    actions: {
      go_to_user: 'Открыть пользователя',
      duplicate_user: 'Дублирование',
      block_user: 'Заблокировать',
    },
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    table: {
      status: 'Status',
      full_name: 'Name',
      email: 'Email',
      role: 'Role',
      last_login_at: 'Last login',
      department: 'Department',
    },
    status: {
      system: 'System',
      active: 'Active',
      blocked: 'Blocked',
      pending: 'Waiting for password setup',
    },
    departments: {
      more: '{{count}} more',
    },
    actions: {
      go_to_user: 'Open user',
      duplicate_user: 'Duplicate',
      block_user: 'Block',
    },
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    table: {
      status: 'Estado',
      full_name: 'Nombre',
      email: 'Email',
      role: 'Rol',
      last_login_at: 'Último inicio',
      department: 'Departamento',
    },
    status: {
      system: 'Sistema',
      active: 'Activo',
      blocked: 'Bloqueado',
      pending: 'Esperando contraseña',
    },
    departments: {
      more: '{{count}} más',
    },
    actions: {
      go_to_user: 'Abrir usuario',
      duplicate_user: 'Duplicar',
      block_user: 'Bloquear',
    },
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    table: {
      status: 'Status',
      full_name: 'Nome',
      email: 'Email',
      role: 'Função',
      last_login_at: 'Último login',
      department: 'Departamento',
    },
    status: {
      system: 'Sistema',
      active: 'Ativo',
      blocked: 'Bloqueado',
      pending: 'Aguardando senha',
    },
    departments: {
      more: 'Mais {{count}}',
    },
    actions: {
      go_to_user: 'Abrir usuário',
      duplicate_user: 'Duplicar',
      block_user: 'Bloquear',
    },
  },
}) : {}) as Record<string, unknown>;
